module.exports = __webpack_public_path__ + "static/media/calandar.d228d012.png";